import PropTypes from "prop-types";
import { useState } from 'react';
import { Card } from '@mui/material';
import ItemResultDialog from "./ItemResultDialog";
import InvoiceResult from "./InvoiceResult";

InvoiceSearchResult.propTypes = {
  searchResult: PropTypes.object,
  search: PropTypes.string,
}
export default function InvoiceSearchResult({ searchResult, search }) {

  const [isDialogOpen, setIsDialogOpen] = useState(false);
  

  return (
    <>
      <Card variant="outlined" sx={{border: "1.5px #e5e9ed solid", p: 2, mb: 2, boxShadow: 'none', borderRadius: '20px'}}>
        <InvoiceResult searchResult={searchResult} search={search} setIsDialogOpen={setIsDialogOpen}/>
      </Card>
      <ItemResultDialog
        searchResult={searchResult}
        search={search}
        open={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        searchType="invoice"
      />
    </>
  );
}